import React, { Component } from 'react';
import { NavBar, SearchBar, Toast } from 'antd-mobile';
import Table from '../../components/Table';
import send from '../../utils/send';
import EmptyReport from '../../components/EmptyReport';

class Farrow19WkDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: [
        {
          id: 'col1',
          title: '序号',
          fixed: true,
          width: 40,
          align: 'left'
        },
        {
          id: 'col2',
          title: '耳号',
          align: 'right',
          width: 170
        },
        {
          id: 'col3',
          title: '状态',
          align: 'right',
          width: 80
        },
        {
          id: 'col4',
          title: '原因',
          align: 'right',
          width: 120
        },
        {
          id: 'col5',
          title: '胎次',
          align: 'right'
        },
        {
          id: 'col6',
          title: '配种次数',
          align: 'right'
        }
        /*{
          id: 'col7',
          title: '空怀',
          align: 'right'
        },
        {
          id: 'col8',
          title: '淘汰',
          align: 'right'
        },
        {
          id: 'col9',
          title: '死亡',
          align: 'right'
        },
        {
          id: 'col10',
          title: '怀孕',
          align: 'right'
        },
        {
          id: 'col11',
          title: '分娩',
          align: 'right'
        }*/
      ],
      dataSource: [],
      details: []
    }
  }

  getDetail = (obj) => {
    Toast.loading('加载中...', 0);
    send({
      url: '/api/forward/ifarm/lossSowBirthWeekDetail',
      method: 'post',
      data: obj
    }).then(res => {
      Toast.hide();
      this.updateTable(res.data);
    }).catch(()=>{})
  };

  updateTable(data) {
    let dataSource = [];
    data.map(obj => {
      let newObj = {};
      newObj['col1'] = data.indexOf(obj) + 1; //序号
      newObj['col2'] = (obj.swineTrack) !== undefined ? (obj.swineTrack) : '-'; //耳号
      newObj['col3'] = (obj.activityType) !== undefined ? (obj.activityType) : '-'; //原因
      newObj['col4'] = (obj.reason) !== undefined ? (obj.reason) : '-';
      newObj['col5'] = (obj.litno1) !== undefined ? (obj.litno1) : '-';
      newObj['col6'] = (obj.litno2) !== undefined ? (obj.litno2) : '-';
     /* newObj['col7'] = (obj.abort_03) !== undefined ? (obj.abort_03) : '-';
      newObj['col8'] = (obj.culled) !== undefined ? (obj.culled) : '-';
      newObj['col9'] = (obj.dead) !== undefined ? (obj.dead) : '-';
      newObj['col10'] = (obj.gestation) !== undefined ? (obj.gestation) : '-';
      newObj['col11'] = (obj.farrow) !== undefined ? (obj.farrow) : '-';*/
      dataSource.push(newObj);
    });

    this.setState({
      details: dataSource,
      dataSource
    });
  }

  componentDidMount() {
    this.getDetail(this.props.data);
  }

  componentWillUnmount() {
    this.setState = () => {

    }
  }

  search = (v) => {
    const results = this.state.dataSource.filter((obj) => {
      let swineId = obj.col3;
      return swineId.indexOf(v || '') >= 0
    });
    this.setState({
      details: results
    })
  };

  render() {
    return (
      <div className="report-detail-bg">
        <div className="report-header">
          <NavBar mode="light">损失母猪</NavBar>
          <SearchBar
              onChange={this.search.bind(this)}
              placeholder="搜索"
          />
        </div>
        <div className="report-content">
          {
            this.state.details.length === 0 ?
              <EmptyReport height={300}
                  width={document.documentElement.clientWidth}
              />
              :
              <Table columns={this.state.columns}
                  data={this.state.details}
              />
          }
          </div>
      </div>
    )
  }
}

export default Farrow19WkDetail;
